export default {
  namespaced: true,
  state: {
    // 最大顶部导航1170，内容1132
    isMobile: window.document.body.clientWidth - 1 < 1200, // 暂时设定小于1200为手机端
    theme: "theme-light",
    showLoginModel: false,
  },
  getters: {
    getIsMobile: (state) => state.isMobile,
    getTheme: (state) => state.theme,
    getShowLoginModel: (state) => state.showLoginModel,
  },
  mutations: {
    setTheme(state, payload) {
      state.theme = payload;
    },
    setShowLoginModel(state, payload) {
      state.showLoginModel = payload;
    },
  },
  actions: {},
};
